module.exports = __webpack_public_path__ + "static/media/KP_photo.afb32473.JPG";